import { useState, useEffect } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { Order } from "./features/Order/screens/Order.component";
import { getUserAccessToken, setUserAccessToken } from "./infra/session";
import { parseItemsFromUrl, saveCartItems, getCartItems } from "./infra/cart-cookie";
import { OrderItem } from "./features/Order/interfaces/order.interface";

import axios, { AxiosResponse } from "axios";

import { User } from "./features/Order/interfaces/user.interface";
import Auth, { AuthLoading } from "./features/Order/components/Auth";

function App() {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [cartItems, setCartItems] = useState<OrderItem[]>([]);

  const recoverUser = async (accessToken: string) => {
    try {
      const result: AxiosResponse<User> = await axios.get(
        `https://www.googleapis.com/oauth2/v3/userinfo`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      setUserAccessToken(accessToken);
      setUser({
        email: result.data.email,
        name: result.data.name,
        picture: result.data.picture,
      });
    } catch (err) {
      console.log(err);
      setUserAccessToken("");
    } finally {
      setIsLoading(false);
    }
  };

  const login = useGoogleLogin({
    onSuccess: (codeResponse: any) => recoverUser(codeResponse?.access_token),
    onError: (error: any) => {
      console.log("Login Failed:", error);
      setIsLoading(false);
    },
  });

  useEffect(() => {
    const fromUrl = parseItemsFromUrl(globalThis.location.search);
    if (fromUrl.length > 0) {
      saveCartItems(fromUrl);
      setCartItems(fromUrl);
    } else {
      setCartItems(getCartItems());
    }

    const accessToken = getUserAccessToken();
    if (accessToken) {
      recoverUser(accessToken);
    } else {
      setIsLoading(false);
    }
  }, []);

  if (isLoading) {
    return <AuthLoading />;
  }

  const logout = () => {
    setUser(null);
    setUserAccessToken("");
    localStorage.removeItem("handler");
  };

  return user ? (
    <Order user={user} onLogout={logout} items={cartItems} />
  ) : (
    <Auth onLogin={() => login()} />
  );
}

export default App;
